module.exports = __webpack_public_path__ + "static/media/professors_slide_1.8156fc5b.png";